module.exports = __webpack_public_path__ + "img/2.097db051.png";